import invoke from "../utils/invoke";

const apikey = process.env.REACT_APP_API_KEY;

export const signUp = async (signupdata) => {
  const data = await invoke({
    url: `/auth/signup`,
    method: "POST",
    headers: { 'Content-Type': 'multipart/form-data' },
    data: signupdata,
  });
  return data;
};

export const logIn = async (loginData) => {
  const data = await invoke({
    url: `/auth/login`,
    method: "POST",
    data: loginData,
  });
  return data;
};

export const logInOnsite = async (loginData) => {
  const data = await invoke({
    url: `/auth/onsite-login`,
    method: "POST",
    data: loginData,
  });
  return data;
};

export const forgotPasswordRequest = async (emailData) => {
  const data = await invoke({
    url: `/auth/forgot-password`,
    method: "POST",
    data: emailData,
  });
  return data;
};

export const resetPassword = async (resetData, token) => {
  const data = await invoke({
    url: `/auth/reset-password/${token}`,
    method: "PUT",
    data: resetData,
  });
  return data;
};

export const submitPhysicalAdmission = async (admissionData) => {
  const data = await invoke({
    url: `/auth/admission`,
    method: "POST",
    headers: { 'Content-Type': 'multipart/form-data' },
    data: admissionData,
  });
  return data;
};

export const registerOnsite = async (onsiteData) => {
  const data = await invoke({
    url: `/onsite/register`,
    method: "POST",
    headers: { 'Content-Type': 'multipart/form-data' },
    data: onsiteData,
  });
  return data;
};

export const getChallan = async (challanId) => {
  const data = await invoke({
    url: `/onsite/challan/${challanId}`,
    method: "GET",
  });
  return data;
};

export const getAdmitCard = async (admitCardId) => {
  const data = await invoke({
    url: `/onsite/admit-card/${admitCardId}`,
    method: "GET",
  });
  return data;
};

export const searchAdmitCard = async (query) => {
  const data = await invoke({
    url: `/onsite/search?q=${encodeURIComponent(query)}`,
    method: "GET",
  });
  return data;
};
